<template>
  <div class="content-parts">
    <div class="column-part">
      <div class="select-part">
        <span style="margin-right: 10px">近期是否有旅游计划：</span>
        <el-switch
          v-model="isWhPlan"
          :width="35"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </div>
      <div class="select-part">
        <span style="margin-right: 10px">是否已办理护照：</span>
        <el-switch
          v-model="isTransact"
          :width="35"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </div>
    </div>
    <div class="column-part" style="margin-top: 30px">
      <span style="margin-right: 10px;margin-top: 0.5rem">近期期望出游路线（国内）：</span>
      <div class="btn-part">
        <span class="single-label" v-for="(el,i) in dealTravel"
              :key="el.id"
        >{{ el.name }}
         <i class="iconfont icon-shanchu3 icon-remove" v-if="isEdit"
            @click="removeTravel(i)"
         ></i>
        </span>
        <span class="single-label"
              style="border: 1px solid #707070;color: #707070;background-color:white"
              v-if="isEdit"
              @click="folder(1,dealTravel,1)"
        >点击添加</span>
      </div>
    </div>
    <div class="column-part" style="margin-top: 10px">
      <span style="margin-right: 10px;margin-top: 0.5rem">近期期望出游路线（国外）：</span>
      <div class="btn-part">
        <span class="single-label"
              v-for="(el,i) in dealTravelForeign"
              :key="el.id"
        >{{ el.name }}
         <i class="iconfont icon-shanchu3 icon-remove" v-if="isEdit"
            @click="removeTravelForeign(i)"
         ></i>
        </span>
        <span class="single-label"
              style="border: 1px solid #707070;color: #707070;background-color:white"
              v-if="isEdit"
              @click="folder(2,dealTravelForeign,2)"
        >点击添加</span>
      </div>
    </div>
    <div class="column-part" style="margin-top: 10px">
      <span style="margin-right: 10px;margin-top: 0.5rem">旅游出行预算（国内）：</span>
      <div class="btn-part" style="margin-left:60px">
        <span class="single-label"
              v-if="!isEdit && travelBudget.name"
        >{{ travelBudget.name }}</span>
        <el-select
          v-if="isEdit"
          v-model="travelBudget.value"
          class="searchInput">
          <el-option
            v-for="item in priceEange"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="column-part" style="margin-top: 10px">
      <span style="margin-right: 10px;margin-top: 0.5rem">旅游出行预算（国外）：</span>
      <div class="btn-part" style="margin-left: 60px">
        <span class="single-label"
              v-if="!isEdit && travelBudgetForeign.name"
        >{{ travelBudgetForeign.name }}</span>
        <el-select
          v-if="isEdit"
          v-model="travelBudgetForeign.value"
          class="searchInput">
          <el-option
            v-for="item in priceEange"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div class="column-part" style="margin-top: 10px">
      <span style="margin-right: 10px;margin-top: 0.5rem">曾经去过的旅游城市（国内）：</span>
      <div class="btn-part" style="margin-left: 10px">
        <span class="single-label"
              v-for="(el,i) in hasTo"
              :key="el.id"
        >{{ el.name }}
         <i class="iconfont icon-shanchu3 icon-remove" v-if="isEdit"
            @click="removeHasTo(i)"
         ></i>
        </span>
        <span class="single-label"
              style="border: 1px solid #707070;color: #707070;background-color:white"
              v-if="isEdit"
              @click="folder(1,hasTo,3)"
        >点击添加</span>
      </div>
    </div>
    <div class="column-part" style="margin-top: 10px">
      <span style="margin-right: 10px;margin-top: 0.5rem">曾经去过的旅游城市（国外）：</span>
      <div class="btn-part" style="margin-left: 10px">
        <span class="single-label"
              v-for="(el,i) in hasToForeign"
              :key="el.id"
        >{{ el.name }}
        <i class="iconfont icon-shanchu3 icon-remove" v-if="isEdit"
           @click="removeHasToForeign(i)"
        ></i>
        </span>
        <span class="single-label"
              style="border: 1px solid #707070;color: #707070;background-color:white"
              v-if="isEdit"
              @click="folder(2,hasToForeign,4)"
        >点击添加</span>
        <div class="compile-btn" v-if="!isEdit" @click="edit">
          <i class="iconfont icon-tianxie" style="font-size: 25px"></i>
          <span>编辑</span>
        </div>
      </div>
    </div>

    <div class="pop-up" v-if="isAddType">
      <div class="search-part">
        <div class="search-title">
          城市选择
          <i class="iconfont icon-shanchu2 iocn"
             @click="closeAddStatus"
          ></i>
        </div>
        <div class="search-input">
          <div class="input">
            <input
              :value="searchWords"
              @input="searchInput"
            ></input>
            <i class="iconfont icon-shanchu1 input-icon"
               v-if="isRemoveText"
               @click="removeSearchContent"
            ></i>
          </div>
          <div class="search-text" @click="search">搜索</div>
          <div class="search-content">
            <div
              v-for="(el,i) in searchs"
              :key="el.id"
              :style="{color:el.isAction ? '#ddd' : (el.isPick ? '#387EFF' : ''),
            pointerEvents:el.isAction ? 'none' : ''
            }"
              @click="checkedSociety(i,el.id)"
            >
              {{ el.name }}
            </div>
          </div>
        </div>
        <div class="search-city-part">
          <div class="left-column">
            <div class="single-left-column"
                 v-for="(el,i) in superiors"
                 :key="el.id"
                 :style="{backgroundColor:el.isScrollAction ? 'white' : ''}"
                 @click="leftTilteSol(i)"
            >
              {{ el.name }}
            </div>
          </div>
          <div class="right-content-part"
               @scroll="rightContentScroll"
               id="rightContentSub">
            <div class="entirety" v-for="(el,i) in subordinates" :key="el.id"
                 :id="el.id"
            >
              <div class="min-title">{{ el.name }}</div>
              <div class="city-content"
                   v-for="(date,index) in el.sub"
                   :key="date.id"
                   :style="{color:date.isAction ? '#ddd' : (date.isPick ? '#387EFF' : ''),
                   pointerEvents:el.isAction ? 'none' : ''}"
                   @click="pickCity(i,index)"
              >{{ date.name }}
              </div>
              <div class="underline"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="search-select-part" v-if="newAddList.length > 0">
        <div class="search-select-title">
          <span @click="cancelAdd">取消</span>
          <span style="font-size:18px;color:black">已选中城市</span>
          <span @click="verifyAdd">确认添加</span>
        </div>
        <div class="search-select-content">
          <div class="single-city-info"
               v-for="el in newAddList"
               :key="el.id"
          >{{ el.name }}
          </div>
        </div>
      </div>
    </div>
    <button class="hold"
            v-if="isEdit"
            @click="holdInfo"
    >保存信息
    </button>
  </div>
</template>

<script>
import axios from "../../axios/axios";
import ipAddress from "../../axios/ipAddress";
import {Message} from "element-ui";

export default {
  name: "unitOne",
  data() {
    return {
      id: '',
      isAddType: false,   //是否添加状态
      isEdit: false,      //是否编辑状态
      isWhPlan: false,
      isTransact: false,
      dealTravel: [],
      dealTravelForeign: [],
      travelBudget: {},
      travelBudgetForeign: {},
      hasTo: [],
      hasToForeign: [],
      priceEange: [],
      newAddList: [],
      superiors: [],
      subordinates: [],
      status: 0, //记录类型
      isRemoveText: false,
      searchWords: '',
      searchs: [],
      alreadyOn: [],   //筛选已经选中的id组合
      unitOneInfo:{}
    }
  },
  created() {
    this.id = this.$route.params.id
    this.travelConsultationInfo();
    this.queryPriceRange()
  },
  methods: {
    //旅游咨询数据信息
    travelConsultationInfo() {
      let params = new URLSearchParams()
      params.set("customerId", this.id)
      axios.post(`${ipAddress.qi}/admin/a1/travel-survey/getByCid`, params).then(
        value => {
          const content = value.content
          this.isWhPlan = content.planJ
          this.isTransact = content.passportJ
          this.dealTravel = content.inlandTravel
          this.dealTravelForeign = content.foreignTravel
          const  inlandTravel =  content.inlandBudget
          if(inlandTravel){
            this.travelBudget = inlandTravel;
          }
          const foreignBudget = content.foreignBudget
          if(foreignBudget){
            this.travelBudgetForeign = foreignBudget
          }
          this.hasTo = content.inlandBeen;
          this.hasToForeign = content.foreignBeen;
          this.unitOneInfo = JSON.parse(JSON.stringify(content))
        }
      )
    },
    //点击编辑
    edit() {
      this.isEdit = true  //改为编辑状态
    },
    //查看价格范围
    queryPriceRange() {
      axios.post(`${ipAddress.qi}/admin/a1/budget-section/list`).then(
        value => {
          const content = value.content
          if (content.length > 0) {
            this.priceEange = content
          }
        }
      )
    },
    //删除期望出游路线，国内
    removeTravel(i) {
      this.dealTravel.splice(i, 1)
    },
    //删除期望出游路线，国外
    removeTravelForeign(i) {
      this.dealTravelForeign.splice(i, 1)
    },
    //删除曾经去旅游城市，国内
    removeHasTo(i) {
      this.hasTo.splice(i, 1)
    },
    //删除曾经去旅游城市，国外
    removeHasToForeign(i) {
      this.hasToForeign.splice(i, 1)
    },
    //保存信息
    holdInfo() {
       if(!((JSON.stringify(this.dealTravel) == JSON.stringify(this.unitOneInfo.inlandTravel))
          && (JSON.stringify(this.dealTravelForeign) == JSON.stringify(this.unitOneInfo.foreignTravel))
          && (JSON.stringify(this.travelBudget)  == JSON.stringify(this.unitOneInfo.inlandBudget))
          && (JSON.stringify(this.travelBudgetForeign) == JSON.stringify(this.unitOneInfo.foreignBudget))
          && (JSON.stringify(this.hasTo) == JSON.stringify(this.unitOneInfo.inlandBeen))
          && (JSON.stringify(this.hasToForeign) == JSON.stringify(this.unitOneInfo.foreignBeen))
          && (this.isWhPlan === this.unitOneInfo.planJ)
          && (this.isTransact === this.unitOneInfo.passportJ))){
            let [travelBudget]  = this.priceEange.filter(el =>el.id === this.travelBudget.value)
            let [travelBudgetForeign] = this.priceEange.filter(el =>el.id === this.travelBudgetForeign.value)
            const travelBudgets =  {...travelBudget,value:travelBudget.id}
            const travelBudgetForeigns = {...travelBudgetForeign,value:travelBudgetForeign.id}
            //修改过数据
            const params = {
              planJ:this.isWhPlan,
              passportJ:this.isTransact,
              inlandBudget:travelBudgets,
              foreignBudget:travelBudgetForeigns,
              inlandTravel:this.dealTravel,
              foreignTravel:this.dealTravelForeign,
              inlandBeen:this.hasTo,
              foreignBeen:this.hasToForeign,
              customerId:this.id
            }
            axios.post(`${ipAddress.qi}/admin/a1/travel-survey/upByCid`,params,true).then(
              value =>{
                const  success = value.success
                const  msg = value.message
                if(success){
                  Message.success("保存成功！")
                  this.isEdit = false
                  this.travelBudget = travelBudgets
                  this.travelBudgetForeign = travelBudgetForeigns
                }else {
                  Message.warning(msg)
                }
              }
            )
       }
    },
    //点击添加
    folder(isInland, list, status) {
      this.status = status
      this.isAddType = true
      //清空初始新增
      this.newAddList = []
      const actionId = list.map(el => el.value)
      this.alreadyOn = actionId
      //请求新数据
      let params = new URLSearchParams()
      params.set("type", isInland)
      axios.post(`${ipAddress.qi}/admin/a1/city/list`, params).then(
        value => {
          const content = value.content
          this.superiors = content.list
          this.subordinates = content.sub.map(el => {
            return {
              ...el, sub: el.sub.map(date => {
                return {...date, isAction: actionId.includes(date.id) ? true : date.isAction}
              })
            }
          })
        }
      )
    },
    //点击关闭添加状态
    closeAddStatus() {
      this.isAddType = false
    },
    //获取左列表的滚动值小范围
    gainMinOffsetTop(id) {
      const elemnt = document.getElementById(`${id}`)
      return elemnt.offsetTop
    },
    //获取左列表的滚动值大范围
    gainMaxOffsetTop(id) {
      const elemnt = document.getElementById(`${id}`)
      return elemnt.offsetTop + elemnt.scrollHeight
    },
    //scroll滚动事件
    rightContentScroll(event) {
      const scrollT = event.target.scrollTop
      this.superiors = this.superiors.map(el => {
        return {
          ...el, isScrollAction: el.min <= scrollT && el.max > scrollT
        }
      })
    },
    //点击列表滚动到对应的位置
    leftTilteSol(i) {
      const titles = this.superiors[i]
      const elemnt = document.getElementById('rightContentSub')
      elemnt.scrollTop = titles.min
    },

    //点击选中该城市
    pickCity(i, index) {
      const city = this.subordinates[i].sub[index]
      if (city.isPick) {  //本来就选中了地
        city.isPick = false
        const subscript = this.newAddList.findIndex(el => el.id === city.id)
        //删除对应的城市
        this.newAddList.splice(subscript, 1)
      } else {
        city.isPick = true
        this.newAddList = [...this.newAddList, city];
      }
    },
    //点击取消添加
    cancelAdd() {
      //关闭添加状态
      this.isAddType = false
    },
    //点击确认添加
    verifyAdd() {
      if (this.newAddList.length > 0) {
        const news = this.newAddList.map(date => {
          return {...date, value: date.id}
        })
        switch (this.status) {
          case 1:
            this.dealTravel = [...this.dealTravel, ...news]
            break
          case 2:
            this.dealTravelForeign = [...this.dealTravelForeign, ...news]
            break
          case 3:
            this.hasTo = [...this.hasTo, ...news]
            break
          case 4:
            this.hasToForeign = [...this.hasToForeign, ...news]
            break
        }
      }
      this.isAddType = false
    },

    //input的input事件
    searchInput(event) {
      const value = event.target.value
      this.searchWords = value
      if (value) {   //存在内容才进行请求数据
        this.isRemoveText = true
        const params = {
          key: value,
          type: this.status === 1 && this.status === 3 ? 2 : 1
        }
        axios.post(`${ipAddress.qi}/admin/a1/city/listLikeKey`, params, true).then(
          value => {
            let content = value.content
            if (content && content.length > 0) {
              content = content.map(el => {
                return {
                  ...el, isAction:
                    this.alreadyOn.includes(el.id) ? true : el.isAction
                }
              })
              this.searchs = content
            } else {
              this.searchs = []
            }
          }
        )
      }
    },
    //点击删除搜索内容
    removeSearchContent() {
      this.searchWords = ''
      this.isRemoveText = false
      this.searchs = []
    },
    //点击搜索
    search() {
      if (this.searchWords) {
        const params = {
          key: this.searchWords,
          type: this.status === 1 && this.status === 3 ? 2 : 1
        }
        axios.post(`${ipAddress.qi}/admin/a1/city/listLikeKey`, params, true).then(
          value => {
            let content = value.content
            if (content && content.length > 0) {
              content = content.map(el => {
                return {
                  ...el, isAction:
                    this.alreadyOn.includes(el.id) ? true : el.isAction
                }
              })
              this.searchs = content
            } else {
              this.searchs = []
            }
          }
        )
      } else {
        Message.warning("请输入相关关键字！")
      }
    },
    //点击选中对应的城市
    checkedSociety(index, id) {
      const search = this.searchs[index]
      if (search.isPick) {
        search.isPick = false
        const index = this.newAddList.findIndex(el => el.id === search.id)
        this.newAddList.splice(index, 1)
      } else {
        search.isPick = true
        this.newAddList = [...this.newAddList, search]
      }
      ;
      this.subordinates = this.subordinates.map(el => {
        return {
          ...el, sub: el.sub.map(item => {
            return {...item, isPick: item.id === id ? !item.isPick : item.isPick}
          })
        }
      })
    }
  },
  watch: {
    subordinates: function () {
      this.$nextTick(() => {
        const elemnt = document.getElementById('rightContentSub')
        const scrollTop = elemnt.scrollTop
        const superiors = this.superiors.map(el => {
          return {
            ...el,
            min: this.gainMinOffsetTop(el.id),
            max: this.gainMaxOffsetTop(el.id),
            isScrollAction: (this.gainMinOffsetTop(el.id) <= scrollTop && this.gainMaxOffsetTop(el.id) > scrollTop)
          }
        })
        this.superiors = superiors
      })
    },
    watch:{
      $route:{
        handler(from,to){
          const fromId = from.params.id
          const  toId = to.params.id
          if(!(fromId == toId)){
            this.id = toId
            this.travelConsultationInfo();
            this.queryPriceRange()
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.content-parts {
  position: relative;
  width: auto;
  height: 100%;
  margin: 0;
  padding: 0;
}

.column-part {
  width: auto;
  height: auto;
  margin-left: 7rem;
  font-size: 0.95rem;
  letter-spacing: 2px;
  display: flex;
}

.select-part {
  width: auto;
  height: auto;
  margin-right: 133px;
  display: flex;
  align-items: center;
}

.btn-part {
  position: relative;
  width: auto;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  margin-left: 26px
}

.single-label {
  position: relative;
  width: auto;
  height: auto;
  background-color: #E4F2FF;
  border: 1px solid #3495EF;
  padding: 0.5rem 1.5rem;
  border-radius: 5px;
  font-size: 0.95rem;
  letter-spacing: 2px;
  color: #3495EF;
  margin-left: 50px;
  margin-bottom: 15px;
}

.compile-btn {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  margin-right: -143px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 0.85rem;
  letter-spacing: 2px;
  color: #387EFF;
}

.pop-up {
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
  margin-top: 0.5rem;
  margin-left: 552px;
  z-index: 9;
  display: flex;
}

.search-part {
  width: 400px;
  height: 777px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}

.search-title {
  position: relative;
  width: 100%;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  letter-spacing: 2px;
  color: black;
}

.iocn {
  position: absolute;
  right: 0;
  top: 0;
  color: red;
  font-size: 21px;
  margin-top: 3px
}

.search-input {
  position: relative;
  width: 100%;
  height: auto;
  background-color: #F5F5F5;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.input {
  width: 304px;
  height: 26px;
  margin: 5px 0;
  display: flex;
  border: 1px solid #707070;
  background-color: white;
  border-radius: 5px;
  align-items: center;
  padding-left: 0.3rem;
}

.search-content {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  font-size: 13px;
  color: black;
  margin-top: 0.5rem;
  letter-spacing: 2px;
}

.search-content div {
  margin-left: 26px;
  margin-bottom: 4px;
}


.input-icon {
  font-size: 11px;
  margin: 0.2rem;
}

.input input {
  border: none;
  outline: none;
  flex: 1;
}

.search-text {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 48px;
  font-size: 15px;
  margin-top: 8px;
  padding-left: 0.5rem;
}

.search-city-part {
  width: 100%;
  height: calc(100% - 43px - 2.5rem);
  display: flex;
}

.left-column {
  width: 90px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #F5F5F5;
}

.single-left-column {
  width: 100%;
  height: 32px;
  display: flex;
  font-size: 16px;
  letter-spacing: 2px;
  padding-left: 8px;
  align-items: center;
}

.right-content-part {
  position: relative;
  width: calc(100% - 92px);
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.entirety {
  width: 100%;
  height: auto;
}

.min-title {
  width: 100%;
  height: 1.5rem;
  display: flex;
  align-items: center;
  margin-left: 21px;
  font-size: 13px;
  letter-spacing: 2px;
  color: #8B8B8B;
}

.city-content {
  width: 100%;
  height: 2rem;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: black;
  letter-spacing: 2px;
  margin-left: 24px
}

.underline {
  width: 80%;
  height: 1px;
  border: 1px solid #F5F5F5;
  margin-left: auto
}

.search-select-part {
  width: 364px;
  height: 260px;
  margin-left: 84px;
  margin-top: 7rem;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}

.search-select-title {
  width: 100%;
  height: 2.5rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 16px;
  letter-spacing: 2px;
  color: #5EABF2;
}

.search-select-content {
  width: 100%;
  height: calc(100% - 2.5rem);
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.single-city-info {
  width: auto;
  height: 36px;
  margin: 0 17px 17px 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #E4F2FF;
  border: 1px solid #3495EF;
  padding: 0 1.5rem;
  border-radius: 5px;
  font-size: 0.95rem;
  letter-spacing: 2px;
  color: #3495EF;
  flex-shrink: 0;
}

.searchInput {
  width: 140px;
  margin-left: 50px;
  margin-bottom: 15px;
}

.icon-remove {
  position: absolute;
  top: 0;
  right: 0;
  margin-top: -8px;
  margin-right: -8px;
  color: #707070;
  font-size: 15px;
}

.hold {
  padding: 0.6rem 1.2rem;
  background-color: #0f86da;
  font-size: 0.95rem;
  letter-spacing: 2px;
  color: white;
  border-radius: 8px;
  border: none;
  margin-top: 27px;
  margin-bottom: 2rem;
  margin-left: 7rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Customer/unitOne.vue